import { AsyncRequestTransform, create } from 'apisauce';

import Env from '../../config/env';
import { getToken } from '../../utils/token.util';

const API = create({
  baseURL: Env.REQUEST_CAIPIRINHA_HOST,
  timeout: 20 * 1000,
});

export const transform: AsyncRequestTransform = async request => {
  if (request.url && request.url.indexOf('auth/customer') === -1) {
    try {
      const token = await getToken();
      if (token) {
        request.headers.Authorization = token;
      }
    } catch {}
  }
};

API.addAsyncRequestTransform(transform);

export default API;
